module.exports = __webpack_public_path__ + "img/wapp.39c66a48.png";